import request from '@/utils/request'
import { reportURL } from '@/config'
export function getPageData(params) {
  return request({
    url: '/api/dashboard',
    method: 'get',
    params,
  })
}
export function getRegionList(params) {
  return request({
    url: '/api/dashboard/tt/regions',
    method: 'get',
    params,
  })
}
export function getTT(params) {
  return request({
    url: '/api/dashboard/tt',
    method: 'get',
    params,
  })
}
export function getFpy(params) {
  return request({
    url: '/api/dashboard/fpy',
    method: 'get',
    params,
  })
}
export function getUtilization(params) {
  return request({
    url: '/api/dashboard/utilization',
    method: 'get',
    params,
  })
}
export function getDashboardRegionlist(params) {
  return request({
    url: '/api/dashboard/regionlist',
    method: 'get',
    params,
  })
}
export function getRatioRegionCodes(params) {
  return request({
    baseURL: reportURL,
    url: '/api/report/getRatioRegionCodes',
    method: 'get',
    params,
  })
}
export function getVaRatioByRegionData(params) {
  return request({
    baseURL: reportURL,
    url: '/api/report/renderVaRatioByRegionCode',
    method: 'get',
    params,
  })
}
export function getVaRatioByStationData(params) {
  return request({
    baseURL: reportURL,
    url: '/api/report/renderVaRatioByStation',
    method: 'get',
    params,
  })
}
export function getVaRatioInPageByStationData(data) {
  return request({
    baseURL: reportURL,
    url: '/api/report/renderVaRatioInPageByStation',
    method: 'post',
    data,
  })
}
export function getVaRatioInPageByRegionData(params) {
  return request({
    baseURL: reportURL,
    url: '/api/report/renderVaRatioInPageByRegionCode',
    method: 'get',
    params,
  })
}
export function getCompletion(url, params) {
  return request({
    url,
    method: 'get',
    params,
  })
}
export function getLosthour(params) {
  return request({
    url: '/api/dashboard/losthour',
    method: 'get',
    params,
  })
}
export function andonsummary(params) {
  return request({
    url: '/api/dashboard/footer/andonsummary',
    method: 'get',
    params,
  })
}
export function getAndontypelist(params) {
  return request({
    url: '/api/dashboard/andontypelist',
    method: 'get',
    params,
  })
}
export function getJobList(params) {
  return request({
    nonstandard: true,
    url: '/api/andon/getJobList',
    method: 'get',
    params,
  })
}
export function responseandon(data) {
  return request({
    url: '/api/dashboard/footer/andonsummary/responseandon',
    method: 'post',
    data,
  })
}
export function closeAndon(data) {
  return request({
    url: '/api/dashboard/footer/andonsummary/closeandon',
    method: 'post',
    data,
  })
}
export function createAndon(data) {
  return request({
    url: '/api/andon/createAndon',
    method: 'post',
    nonstandard: true,
    data,
  })
}
export function andonsummaryByRegion(regionCode) {
  return request({
    url: '/api/dashboard/region/andonsummary',
    method: 'get',
    params: {
      regionCode,
    },
  })
}
